import React from 'react';
import { FooterBase } from './styles';

function Footer() {
  return (
    <FooterBase>
       © 2020 |{' '} 
       <a href="https://k0rgana.github.io/">k0rgana</a>
       . Criado com muito ❤ e orgulho em Quarentena.
    </FooterBase>
  );
}

export default Footer;
